/**
 * Rotulos do "modo foco" da lista nominal, por eixo.
 *
 * No fluxo padrao (boas praticas: C2-C7, eSB, eMulti, eCR...) a lista parte de CIDADAOS e o
 * `status` significa: faltam = nao cumpriu a boa pratica | entraram = cumpriu.
 *
 * No C1 - Mais Acesso a unidade contada e o ATENDIMENTO, e a particao e por TIPO DE DEMANDA.
 * O contrato do parametro `status` NAO muda (evita ramificar service, controller, cache, CSV e
 * PDF por eixo):
 *
 *   status = 'entraram' -> ind_a = 1 -> atendimento PROGRAMADO  (= numerador do card)
 *   status = 'faltam'   -> ind_a = 0 -> atendimento ESPONTANEO  (= denominador - numerador)
 *
 * Este modulo traduz apenas o que o usuario le. Espelha
 * backend/src/saude/indicadores/foco-labels.util.ts (CSV/PDF).
 */

/** Eixos cuja lista de foco particiona ATENDIMENTOS por tipo de demanda (em vez de boa pratica). */
export const EIXOS_FOCO_TIPO_DEMANDA = new Set<string>(['c1-mais-acesso']);

export function isFocoTipoDemanda(eixo?: string): boolean {
  return !!eixo && EIXOS_FOCO_TIPO_DEMANDA.has(eixo);
}

/** Rotulos do toggle. Os VALORES continuam 'faltam'/'entraram' (contrato da API). */
export function focoStatusLabels(eixo?: string): { faltam: string; entraram: string } {
  return isFocoTipoDemanda(eixo)
    ? { faltam: 'Espontaneos', entraram: 'Programados' }
    : { faltam: 'Faltam', entraram: 'Entraram' };
}

/**
 * Lado aberto ao clicar no card. Nos eixos de boa pratica abre em "faltam" (a acao pendente);
 * no C1 abre em "programados", que e o numerador exibido no proprio card.
 */
export function focoStatusDefault(eixo?: string): 'faltam' | 'entraram' {
  return isFocoTipoDemanda(eixo) ? 'entraram' : 'faltam';
}

/** Cabecalho da coluna de data na tabela do modo foco. */
export function focoDataLabel(eixo?: string): string {
  return isFocoTipoDemanda(eixo) ? 'Data do atendimento' : 'Data';
}

/** Sufixo do titulo da tela em modo foco. */
export function focoTituloSufixo(eixo?: string): string {
  return isFocoTipoDemanda(eixo) ? 'Tipo de Demanda' : 'Boa Pratica';
}

/** Sufixo do nome dos arquivos exportados (CSV/PDF). */
export function focoStatusSlug(eixo: string | undefined, status?: string): string {
  const entraram = status === 'entraram';
  if (isFocoTipoDemanda(eixo)) return entraram ? 'programados' : 'espontaneos';
  return entraram ? 'entraram' : 'faltam';
}
